import { defineStore } from 'pinia';
import { useUserStore } from '@/stores/userStore';

export const useBroadcastStore = defineStore('broadcast', {
    state: () => ({
        userStore: null,
    }),
    actions: {
        init() {
            this.userStore = useUserStore();
        },
        subscribeBalance() {
            const userStore = this.userStore;
            if(!userStore.isAuthenticated) return;

            const userId = userStore.user.id;

            window.Echo.private(`balance.${userId}`)
                .listen('.BalanceChanged', (e) => {
                    console.log('Balance update received:', e);
                    if (e?.user?.balance !== undefined) {
                        userStore.updateUser({ balance: e.user.balance });
                    }

                    if(e?.user?.referral_balance !== undefined) {
                        userStore.updateUser({ referral_balance: e.user.referral_balance });
                    }
                });
        }
    }
});
